import { render } from "./ColorButton.vue?vue&type=template&id=165c50f5&scoped=true"
import script from "./ColorButton.vue?vue&type=script&lang=js"
export * from "./ColorButton.vue?vue&type=script&lang=js"

import "./ColorButton.vue?vue&type=style&index=0&id=165c50f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165c50f5"]])

export default __exports__